import {Component, OnInit} from '@angular/core';
import {DoodlesService} from '../../doodles.service';
import {DoodleModel} from '../../doodle-model';

@Component({
  selector: 'app-wolf',
  templateUrl: './wolf.component.html',
  styleUrls: ['./wolf.component.less', '../../doodles.component.less']
})
export class WolfComponent implements OnInit {
  public model: DoodleModel;

  constructor(
    private doodlesService: DoodlesService
  ) { }

  ngOnInit(): void {
    this.model = this.doodlesService.doodleModel;
  }

}
